import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import 'firebase/auth';
import { AlertService } from './alert.service';
import { StorageService } from './storage.service';
import { LoaderServiceService } from './loader-service.service';
import { environment } from 'src/environments/environment';
import { Platform } from '@ionic/angular';
// import Cookies from 'js-cookie';
import * as CryptoJS from 'crypto-js';
import Cookies from "js-cookie";
import { CustomConfirmDialogComponent } from '../shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../shared/constants/sm-constants';
import { Observable, throwError } from 'rxjs';
import { map, retryWhen, scan, delay, catchError } from 'rxjs/operators';
import { AutoLoginLoaderService } from './auto-login-loader.service';
import { HttpClient } from '@angular/common/http';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _recaptchaVerifier: any;
  private _confirmationResult: any = '';
  private readonly COOKIE_NAME = 'user_role';
  private readonly SECRET_KEY = environment.cookie_hex_key;
  constructor(
    private _fireAuth: AngularFireAuth,
    private _router: Router,
    private dialog: MatDialog,
    private _alertService: AlertService,
    private _storageService: StorageService,
    private loaderservice:LoaderServiceService,
    private alloader:AutoLoginLoaderService,
    private http:HttpClient,
    private platform: Platform
  ) {}

  initRecaptcha(buttonRef: HTMLButtonElement) {
    if (this.platform.is('capacitor')) {
      // Native platform (iOS/Android) - no need for web recaptcha
      return;
    }
    else{
      this._recaptchaVerifier = new firebase.auth.RecaptchaVerifier(buttonRef, {
        size: 'invisible',
        'expired-callback': () => {
          console.log('captcha expired');
        },
      });

    }
  }

  
  private otpListeners: { remove: () => void }[] = [];

  async onReceiveOTP(phoneNumber: string) {
   
    if (this.platform.is('capacitor')) {
      try {
        this.loaderservice.showLoader = true;
  
        const verificationPromise = new Promise<boolean>((resolve, reject) => {
          let resolved = false;
  
          // ✅ Event: OTP sent
          const phoneCodeSentListener = FirebaseAuthentication.addListener(
            'phoneCodeSent',
            async (event: { verificationId: string }) => {
              console.log('OTP sent! verificationId:', JSON.stringify(event));
              // resolved = true
              this._confirmationResult = event.verificationId;
              resolve(true)
             
            }
          );
  
       

          const phoneVerificationFailedListener =  FirebaseAuthentication.addListener('phoneVerificationFailed', async (error: any) => {
            console.error('Phone verification failed:', JSON.stringify(error));
            resolved = false
            resolve(false)
            this.loaderservice.showLoader = false;
          
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width:'500px',
              data: {
                title: "System error!",
                message:
                  "There is some issue with the phone number you entered. Check the number for once. Or try again.",
                okbtn: 'Ok',
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
              });
  
          // Start the process (fires the above listeners)
          FirebaseAuthentication.signInWithPhoneNumber({ phoneNumber }).catch(err => {
            console.error('sendOTP failed:', err);
            if (!resolved) reject(err);
          });
        });
  
        const result = await verificationPromise;
        console.log('main result after otp', result);
        
        this.loaderservice.showLoader = false;
        return result;
      } catch (error) {
        console.error('Native sendOTP failed', error);
        this.loaderservice.showLoader = false;
  
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          width:'500px',
          data: {
            title: "System error!",
            message:
              "There is some issue with the phone number you entered. Check the number for once. Or try again.",
            okbtn: 'Ok',
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
  
        return false;
      }
    }
    else{
      try {
        console.log(phoneNumber);
        
        this.loaderservice.showLoader = true
        const result = await this._fireAuth.signInWithPhoneNumber(
          phoneNumber,
          this._recaptchaVerifier
        );
        this.loaderservice.showLoader = false
        console.log(result);
        this._confirmationResult = result;
        return true;
      } catch (error) {
        console.log('Login error trace', error);
        
        this.loaderservice.showLoader = false
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          width:'500px',
          data: {
            title: "System error!",
            message:
              "There is some issue with the phone number you entered. Check the number for once. Or try again.",
            okbtn: 'Ok',
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        return false;
      }

    }
  }

  async resendOTP(phoneNumber: string) {
   
    if (this.platform.is('capacitor')) {
      try {
        this.loaderservice.showLoader = true;
  
        const verificationPromise = new Promise<boolean>((resolve, reject) => {
          let resolved = false;
  
          // ✅ Event: OTP sent
          const phoneCodeSentListener = FirebaseAuthentication.addListener(
            'phoneCodeSent',
            async (event: { verificationId: string }) => {
              console.log('OTP sent! verificationId:', JSON.stringify(event));
              // resolved = true
              this._confirmationResult = event.verificationId;
              resolve(true)
             
            }
          );
  
       

          const phoneVerificationFailedListener =  FirebaseAuthentication.addListener('phoneVerificationFailed', async (error: any) => {
            console.error('Phone verification failed:', JSON.stringify(error));
            resolved = false
            resolve(false)
            this.loaderservice.showLoader = false;
          
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width:'500px',
              data: {
                title: "System error!",
                message:
                  "There is some issue with the phone number you entered. Check the number for once. Or try again.",
                okbtn: 'Ok',
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
              });
  
          // Start the process (fires the above listeners)
          FirebaseAuthentication.signInWithPhoneNumber({ phoneNumber,resendCode:true }).catch(err => {
            console.error('sendOTP failed:', err);
            if (!resolved) reject(err);
          });
        });
  
        const result = await verificationPromise;
        console.log('main result after otp', result);
        
        this.loaderservice.showLoader = false;
        return result;
      } catch (error) {
        console.error('Native sendOTP failed', error);
        this.loaderservice.showLoader = false;
  
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          width:'500px',
          data: {
            title: "System error!",
            message:
              "There is some issue with the phone number you entered. Check the number for once. Or try again.",
            okbtn: 'Ok',
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
  
        return false;
      }
    }
    else{
      try {
        console.log(phoneNumber);
        
        this.loaderservice.showLoader = true
        const result = await this._fireAuth.signInWithPhoneNumber(
          phoneNumber,
          this._recaptchaVerifier
        );
        this.loaderservice.showLoader = false
        console.log(result);
        this._confirmationResult = result;
        return true;
      } catch (error) {
        console.log('Login error trace', error);
        
        this.loaderservice.showLoader = false
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          width:'500px',
          data: {
            title: "System error!",
            message:
              "There is some issue with the phone number you entered. Check the number for once. Or try again.",
            okbtn: 'Ok',
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        return false;
      }

    }
  }
  
  private cleanupOtpListeners() {
    this.otpListeners.forEach(listener => listener.remove());
    this.otpListeners = [];
  }
  
  private showOtpErrorDialog() {
    this.dialog.open(CustomConfirmDialogComponent, {
      width: '500px',
      data: {
        title: "System error!",
        message: "There is some issue with the phone number you entered. Check the number for once. Or try again.",
        okbtn: 'Ok',
        type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
      },
      disableClose: true,
    });
  }


  async onSignInWithPhone(otp: string) {
    if (this.platform.is('capacitor')) {
      // Native
      try {
        this.loaderservice.showLoader = true
        const result = await FirebaseAuthentication.confirmVerificationCode({
          verificationId: this._confirmationResult,
          verificationCode: otp
        });
        const customToken = await this.getCustomToken(result.user!.uid).toPromise(); // Use toPromise() instead of firstValueFrom
        if (!customToken) {
          console.error('Custom token is null, auto-login failed');
          this.alloader.showLoader = false
          this.loaderservice.showLoader = false
          return;
        }

        const sdkuserCredential = await this._fireAuth.signInWithCustomToken(customToken);
        console.log('sdk user ',JSON.stringify(sdkuserCredential.user));
        
        this.loaderservice.showLoader = false
        return result;
      } catch (error) {
        console.error('Native verifyOTP failed', error);
        this.loaderservice.showLoader = false
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: 'Alert',
            message:
              'Re-check the verification code. If the code is correct, there must be some other issue.',
            okbtn: 'Ok',
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        return null;
      }
    }
    else{
      try {
        this.loaderservice.showLoader = true
        const result = await this._confirmationResult.confirm(otp);
        console.log(result);
        console.log(result.user);
        
        if (result.user) {
          console.log(result.user.uid);
          document.cookie = `fbid=${result.user.uid};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
        }
        this.loaderservice.showLoader = false
        return result;
      } catch (error) {
        console.log(error);
        
        this.loaderservice.showLoader = false
        console.error(error);
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: 'Alert',
            message:
              'Re-check the verification code. If the code is correct, there must be some other issue.',
            okbtn: 'Ok',
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        return null;
      }

    }
  }

  async autoLogin() {
    const uid = this.getCookie('fbid'); // Read UID from cookie
    if (!uid) {
      console.error('No UID found in cookies');
      this.alloader.showLoader = false
      return;
    }

    try {
      this.alloader.showLoader = true
      const customToken = await this.getCustomToken(uid).toPromise(); // Use toPromise() instead of firstValueFrom
      if (!customToken) {
        console.error('Custom token is null, auto-login failed');
        this.alloader.showLoader = false
        return;
      }

      const userCredential = await this._fireAuth.signInWithCustomToken(customToken);
      console.log('user',userCredential);
      
      return userCredential.user;
    } catch (error) {
      console.error('Auto-login failed:', error);
      this.alloader.showLoader = false
      throw error; // Allows .then/.catch when calling autoLogin()
    }
  }

  getCookie(name: string): string | null {
    const matches = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return matches ? decodeURIComponent(matches[1]) : null;
  }

 

  async onSignOut() {
    if (this.platform.is('capacitor')){
      try {
        const result = await FirebaseAuthentication.signOut();
        const resultsdk = await this._fireAuth.signOut()
        
        this.clearAllCookies()
        this._storageService.clearAppStorage();
        this._storageService.clearLocalStorage();
        this.clearUserRole();
        this.loaderservice.showLoader = false
        this.alloader.showLoader = false
        this._router.navigateByUrl('/login').then((_) => {
          this._alertService.onOpenSnackbar('Signed out successfully');
        });
      } catch (error) {
        console.error('Native signOut failed', error);
        throw error;
      }
    }
    else{
      this._fireAuth
        .signOut()
        .then((_:any) => {
          this.clearAllCookies()
          this._storageService.clearAppStorage();
          this._storageService.clearLocalStorage();
          this.clearUserRole();
          this.loaderservice.showLoader = false
          this.alloader.showLoader = false
          this._router.navigateByUrl('/login').then((_) => {
            this._alertService.onOpenSnackbar('Signed out successfully');
          });
        })
        .catch((error:any) => console.error(error));

    }
  }
  async onSignOutAfterDeactivate() {
    if (this.platform.is('capacitor')){
      try {
        const result = await FirebaseAuthentication.signOut();
        const resultsdk = await this._fireAuth.signOut()
        
        this.clearAllCookies()
        this._storageService.clearAppStorage();
        this._storageService.clearLocalStorage();
        this.clearUserRole();
        this.loaderservice.showLoader = false
        this.alloader.showLoader = false
        this._router.navigateByUrl('/login').then((_) => {
          this._alertService.onOpenSnackbar('Account de-activated successfully.');
        });
      } catch (error) {
        console.error('Native signOut failed', error);
        throw error;
      }
    }
    else{
      this._fireAuth
        .signOut()
        .then((_:any) => {
          this.clearAllCookies()
          this._storageService.clearAppStorage();
          this._storageService.clearLocalStorage();
          this.clearUserRole();
          this.loaderservice.showLoader = false
          this.alloader.showLoader = false
          this._router.navigateByUrl('/login').then((_) => {
            this._alertService.onOpenSnackbar('Account de-activated successfully.');
          });
        })
        .catch((error:any) => console.error(error));

    }
  }
  async onSignOutAfterPhoneChange() {
    if (this.platform.is('capacitor')){
      const result = await FirebaseAuthentication.signOut();
      const resultsdk = await this._fireAuth.signOut()
      this.clearAllCookies()
      this._storageService.clearAppStorage();
      this._storageService.clearLocalStorage();
      this.clearUserRole();
      this.loaderservice.showLoader = false
      this.alloader.showLoader = false
      this._router.navigateByUrl('/login').then((_) => {
        this._alertService.onOpenSnackbar('Phone number changed successfully. Please log in again with the new number.', 5000, 'Ok');
      });
    }
    else{
      this._fireAuth
        .signOut()
        .then((_) => {
          this.clearAllCookies()
          this._storageService.clearAppStorage();
          this._storageService.clearLocalStorage();
          this.clearUserRole();
          this.loaderservice.showLoader = false
          this.alloader.showLoader = false
          this._router.navigateByUrl('/login').then((_) => {
            this._alertService.onOpenSnackbar('Phone number changed successfully. Please log in again with the new number.', 5000, 'Ok');
          });
        })
        .catch((error) => console.error(error));

    }
  }
  async onSignOutWithoutRedirect() {
    if (this.platform.is('capacitor')){
      const result = await FirebaseAuthentication.signOut();
      const resultsdk = await this._fireAuth.signOut()
      this.clearAllCookies()
      this._storageService.clearAppStorage();
      this._storageService.clearLocalStorage();
      this.clearUserRole();
      this.loaderservice.showLoader = false
      this.alloader.showLoader = false
    }
    else{
      this._fireAuth
        .signOut()
        .then((_:any) => {
          this.clearAllCookies()
          this._storageService.clearAppStorage();
          this._storageService.clearLocalStorage();
          this.clearUserRole();
          this.loaderservice.showLoader = false
          this.alloader.showLoader = false
        })
        .catch((error:any) => console.error(error));

    }
  }

  onSignOutWithoutMessage() {   
    this._fireAuth
      .signOut()
      .then((_) => {
        this.clearAllCookies()
        this._storageService.clearAppStorage();
        this._storageService.clearLocalStorage();
        this._storageService.clearSessionStorage();
        this.clearUserRole();
        this.loaderservice.showLoader = false
        this.alloader.showLoader = false
        this._router.navigate(['/login'],{queryParamsHandling: 'preserve'})
        
      })
      .catch((error) => console.error(error));
  }


  async delete() {
    try {
      // Get the current user
      const user = await this._fireAuth.currentUser;
      
      console.log(user);
      user?.delete().then((res:any) => {
       console.log(res);
       
     });
      return true;
    } catch (error:any) {
      console.error(error);
      // Handle errors appropriately
      alert(error.message);
      return false;
    }
  }

  async check() {
    try {
      // Get the current user
      const user = await this._fireAuth.currentUser;
      
      console.log(user);
      return true;
    } catch (error:any) {
      console.error(error);
      // Handle errors appropriately
      alert(error.message);
      return false;
    }
  }


  async changePhoneNumber(otp: string) {
    if (this.platform.is('capacitor')) {
      try {
        this.loaderservice.showLoader = true
        if (!this._confirmationResult) {
          throw new Error('Missing confirmationResult. Request OTP first.');
        }

        console.log(this._confirmationResult);
        
        // Step 1: Get currently logged in user
        const user = firebase.auth().currentUser;
        if (!user) {
          throw new Error('User not logged in.');
        }

        console.log('userrrrr',JSON.stringify(user));
    
        
        // Step 2: Create a phone credential
        const verificationId = this._confirmationResult;
    
        const credential = firebase.auth.PhoneAuthProvider.credential(
          verificationId,
          otp
        );

        console.log(JSON.stringify(credential));
        
    
        
        
    
        // Step 3: Update phone number using the credential
        const result = await user.updatePhoneNumber(credential);
        this.loaderservice.showLoader = false
        return result;
      } catch (error) {
        this.loaderservice.showLoader = false
        console.error('Failed to update phone number:', error);
        throw error;
      }
    }
    else{
      try {
        this.loaderservice.showLoader = true
        // Get the current user
        const user = await this._fireAuth.currentUser;
        
        console.log(user);
        console.log(this._confirmationResult);
        
        // Create a phone credential with the new phone number and the verification code (OTP)
        const credential = firebase.auth.PhoneAuthProvider.credential(
          this._confirmationResult.verificationId,
          otp
        );
        console.log(credential);
          
        // Reauthenticate the user with the phone credential
        // const res =  await user!.reauthenticateWithCredential(credential);
        // console.log(res);
          
        // Update the phone number
        const result = await user!.updatePhoneNumber(credential);
        console.log(result);
        this.loaderservice.showLoader = false
        return result;
      } catch (error) {
        this.loaderservice.showLoader = false
        console.error(error);
        // Handle errors appropriately
        // alert(error.message);
        throw error;
      }

    }
  }

  async getToken(): Promise<string | null> {
    if (this.platform.is('capacitor')) {
      try {
        const result = await FirebaseAuthentication.getIdToken();
        return result.token ?? null;
      } catch (error) {
        console.error('Error getting native token:', error);
        return null;
      }
    }
    else{
      const user = await new Promise<firebase.User | null>((resolve) => {
        const unsubscribe = this._fireAuth.onAuthStateChanged(async (currentUser:any) => {
          (await unsubscribe)(); // Unsubscribe after receiving the user state
          resolve(currentUser);
        });
      });
  
      if (user) {
        console.log(JSON.stringify(user));
        
        const token = await user.getIdToken(); // true forces a refresh
        return token;
      }
      return null;
      
    }
  }








  // COOKIE-POLICY FOR USER ROLE
  
  private generateHMAC(data: string): string {
    return CryptoJS.HmacSHA256(data, this.SECRET_KEY).toString();
  }

  setUserRole(role: 'owner' | 'employee'): void {
    const signature = this.generateHMAC(role);
    const valueWithSignature = `${role}.${signature}`;
    Cookies.set(this.COOKIE_NAME, valueWithSignature, { expires: 1, secure: true, sameSite: 'Strict' });
  }


  getUserRole(): 'owner' | 'employee' | null {
    const storedValue = Cookies.get(this.COOKIE_NAME);
    if (!storedValue) return null;

    const [role, signature] = storedValue.split('.');
    if (!role || !signature) return null; // Invalid format

    const validSignature = this.generateHMAC(role);
    if (signature !== validSignature) {
      console.warn('Tampering detected! Invalid cookie.');
      this.clearUserRole(); // Remove tampered cookie
      return null;
    }

    return role === 'owner' || role === 'employee' ? role as 'owner' | 'employee' : null;
  }


  clearUserRole(): void {
    Cookies.remove(this.COOKIE_NAME);
  }


  isOwner(): boolean {
    return this.getUserRole() === 'owner';
  }

  isEmployee(): boolean {
    return this.getUserRole() === 'employee';
  }


  
  clearAllCookies() {
    const domains = [window.location.hostname, ".lookzup.com"];

    // Extract all subpaths the user has visited based on the current URL
    const pathname = window.location.pathname; // e.g., "/business/GlamourSalon&Spa"
    const subpaths = pathname.split("/").filter(p => p); // Remove empty entries

    // Generate all possible paths where cookies might exist
    const paths = ["/"];
    let currentPath = "";
    subpaths.forEach(sub => {
      currentPath += `/${sub}`;
      paths.push(currentPath);
    });

    // Loop through all cookies and delete them for each path & domain
    document.cookie.split(";").forEach(cookie => {
      const [name] = cookie.split("=");
      domains.forEach(domain => {
        paths.forEach(path => {
          document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`;
        });
      });
    });

    console.log("All cookies cleared for paths:", paths);
  }


  private apiUrl = 'https://us-central1-lookzup-platform.cloudfunctions.net/getCustomAuthToken';

  getCustomToken(uid: string): Observable<string> {
    return this.http.post(this.apiUrl, { uid }, { responseType: 'text' }).pipe(
      map(response => {
        if (!response) {
          throw new Error('Empty response received'); // Force retry if empty
        }
        return response; // Return valid token
      }),
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 5) {
              throw error; // Stop after 5 retries
            }
            console.warn(`Retry ${retryCount + 1}: Retrying getCustomToken...`);
            return retryCount + 1;
          }, 0),
          delay(500) // Wait 1 second before each retry
        )
      ),
      catchError(error => {
        console.error('Final failure after retries:', error);
        return throwError(() => new Error('Failed to fetch custom token after multiple attempts'));
      })
    );
  }

}
